import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Input,
  message,
  Popconfirm,
  Segmented,
  Switch,
  Table,
  Tooltip,
} from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { SERVER_ADDRESS } from "../../../Config/Config";
import { PiTrashDuotone } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

const ViewAudio = () => {
  const [selectedOption, setSelectedOption] = useState("For You");
  const options = ["For You", "Trending", "Recommednded"];
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const userData = JSON.parse(
    atob(localStorage.getItem("token").split(".")[1])
  );
  const userPermission = userData.privelege || [];
  const navigate = useNavigate();
  const columns = [
    {
      title: "Audio Name",
      dataIndex: "audio_name",
      key: "audio_name",
      align: "center",
    },
    {
      title: "Audio",
      key: "audio_url",
      render: (_, record) => {
        return (
          <>
            {record?.audio_url ? (
              <audio
                controls
                src={record.audio_url}
                style={{ width: "300px" }}
              />
            ) : (
              "No audio available"
            )}
          </>
        );
      },
      align: "center",
    },
    {
      title: "Active Status",
      key: "is_active",
      render: (_, record) => {
        const active = record?.is_active;
        const id = record?.id;
        return (
          <>
            <Switch
              onChange={() => {
                active_audio(id, active);
              }}
              checked={active}
            />
          </>
        );
      },
      align: "center",
    },
    {
      title: "Options",
      key: "options",
      align: "center",
      render: (_, record) => {
        const audio_url = record.audio_url;
        const id = record.id;
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <Tooltip title="Edit">
              <Button onClick={()=>{navigate("/edit-audio",{state:record})}} variant="filled" color="blue">
                <EditOutlined />
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Popconfirm
                onConfirm={() => {
                  handleDelete(id, audio_url);
                }}
                title="Are You sure want to delete ?"
              >
                <Button variant="filled" color="danger">
                  <PiTrashDuotone />
                </Button>
              </Popconfirm>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const active_audio = async (id, active_status) => {
    const values = {
      id,
      active_status,
      type: 1,
    };
    try {
      const response = await axios.post(
        `${SERVER_ADDRESS}/api/trigger-audio`,
        values
      );
      const result = response.data;
      if (result?.result === 1) {
        fetch_data();
        message.success(result?.message);
      } else {
        message.warning(result?.message);
      }
    } catch (error) {
      console.log(error);
      message.error(error);
    }
  };

  const handleDelete = async (id, audio_url) => {
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/delete-audio`, {
        id,
        audio_url,
      });
      const result = response.data;
      if (result.result === 1) {
        fetch_data();
        message.success(result?.message);
      } else {
        message.warning(result?.message);
      }
    } catch (error) {
      console.log(error);
      message.error({ content: "Something went wrong" });
    }
  };

  useEffect(() => {
    fetch_data();
  }, [selectedOption]);

  const fetch_data = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/view-audio`, {
        type: selectedOption,
      });
      const orgResult = response.data;
      if (orgResult.result === 1) {
        setData(orgResult?.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      message.error("Something went wrong");
    }
  };

  const renderTable = () => {
    switch (selectedOption) {
      case "For You":
        return (
          <div>
            <div style={{ marginTop: "1rem" }}>
              <Input
                placeholder="Search by audio name"
                style={{ width: "15rem" }}
                prefix={<SearchOutlined />}
              />
            </div>
            <Table
              dataSource={data}
              loading={loading}
              columns={columns}
              style={{ marginTop: "1rem" }}
              rowKey={"id"}
            />
          </div>
        );
      case "Trending":
        return (
          <div>
            <div style={{ marginTop: "1rem" }}>
              <Input
                placeholder="Search by audio name"
                style={{ width: "15rem" }}
                prefix={<SearchOutlined />}
              />
            </div>
            <Table
              columns={columns}
              dataSource={data}
              loading={loading}
              style={{ marginTop: "1rem" }}
              rowKey={"id"}
            />
          </div>
        );
      case "Recommednded":
        return (
          <div>
            <div style={{ marginTop: "1rem" }}>
              <Input
                placeholder="Search by audio name"
                style={{ width: "15rem" }}
                prefix={<SearchOutlined />}
              />
            </div>
            <Table
              dataSource={data}
              loading={loading}
              columns={columns}
              style={{ marginTop: "1rem" }}
              rowKey={"id"}
            />
          </div>
        );
      default:
        break;
    }
  };
  return (
    <div style={{ marginTop: "4rem" }}>
      <Segmented
        selected={selectedOption}
        onChange={setSelectedOption}
        options={options}
        block
      />
      <div style={{ marginTop: "2rem" }}>{renderTable()}</div>
    </div>
  );
};

export default ViewAudio;
